(() => {
  const STORAGE_KEY = 'mcor_fit_guide_vehicle_v1';
  const FIT_GUIDE_PATH = '/pages/speaker-fit-guide';
  const VEHICLE_PARAMS = {
    year: 'fg_year',
    make: 'fg_make',
    model: 'fg_model',
    submodel: 'fg_submodel',
    body_style: 'fg_body',
    screen: 'fg_screen',
    amplifier: 'fg_amp',
    hvac: 'fg_hvac',
    key_type: 'fg_key',
    transmission: 'fg_trans',
    powertrain: 'fg_powertrain',
  };

  const readVehicle = () => {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (_error) {
      return null;
    }
  };

  const hasVehicle = (vehicle) => Boolean(vehicle?.year && vehicle?.make && vehicle?.model);

  const vehicleLabel = (vehicle) =>
    hasVehicle(vehicle) ? [vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(' ') : '';

  const fitGuideUrl = (anchor) => {
    const url = new URL(FIT_GUIDE_PATH, window.location.origin);
    const vehicle = readVehicle();
    if (hasVehicle(vehicle)) {
      Object.entries(VEHICLE_PARAMS).forEach(([field, parameter]) => {
        if (vehicle[field]) url.searchParams.set(parameter, vehicle[field]);
      });
    }
    url.hash = anchor;
    return `${url.pathname}${url.search}${url.hash}`;
  };

  const addStyles = () => {
    if (document.getElementById('McorJlConversionStyles')) return;
    const style = document.createElement('style');
    style.id = 'McorJlConversionStyles';
    style.textContent = `
      .mcor-jl-conversion{margin:1.6rem 0;padding:1.8rem;border:1px solid rgba(var(--color-foreground),.16);border-left:4px solid #e21b23;border-radius:12px;background:rgba(var(--color-foreground),.025)}
      .mcor-jl-conversion__eyebrow{margin:0 0 .45rem;color:#d71920;font-size:1.1rem;font-weight:800;letter-spacing:.09em;text-transform:uppercase}
      .mcor-jl-conversion h2{margin:0 0 .65rem;font-size:clamp(1.8rem,2.2vw,2.35rem);line-height:1.15}
      .mcor-jl-conversion__copy{margin:0 0 1.25rem;color:rgba(var(--color-foreground),.78);line-height:1.55}
      .mcor-jl-conversion__actions{display:flex;flex-wrap:wrap;gap:.8rem;align-items:center}
      .mcor-jl-conversion__primary{display:inline-flex;align-items:center;justify-content:center;min-height:4.5rem;padding:.9rem 1.4rem;border-radius:8px;background:#e21b23;color:#fff;text-decoration:none;font-weight:800;text-align:center}
      .mcor-jl-conversion__primary:hover{background:#b9141a;color:#fff}
      .mcor-jl-conversion__secondary{color:rgb(var(--color-foreground));font-weight:700;text-underline-offset:.3rem}
      .mcor-jl-trust{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:.65rem 1.2rem;margin-top:1.35rem;padding-top:1.15rem;border-top:1px solid rgba(var(--color-foreground),.12);font-size:1.2rem;font-weight:650}
      .mcor-jl-trust span::before{content:'✓';margin-right:.45rem;color:#118047;font-weight:900}
      .mcor-jl-filter-summary{display:flex;align-items:center;justify-content:space-between;gap:1.2rem;margin:0 auto 2rem;padding:1.4rem 1.6rem;border:1px solid rgba(var(--color-foreground),.14);border-radius:10px;background:rgba(var(--color-foreground),.025)}
      .mcor-jl-filter-summary strong{display:block;font-size:1.55rem}
      .mcor-jl-filter-summary span{display:block;margin-top:.2rem;color:rgba(var(--color-foreground),.7)}
      .mcor-jl-filter-summary a{white-space:nowrap;font-weight:800;text-underline-offset:.3rem}
      body.mcor-jl-filtered-collection .mcor-authority-hub{display:none!important}
      body.mcor-jl-filtered-collection .collection-hero__description{display:none!important}
      body.mcor-jl-filtered-collection .collection-hero__inner{padding-bottom:1.5rem!important}
      @media(max-width:749px){.mcor-jl-conversion{padding:1.5rem}.mcor-jl-conversion__primary{width:100%}.mcor-jl-trust{grid-template-columns:1fr}.mcor-jl-filter-summary{align-items:flex-start;flex-direction:column}.mcor-jl-filter-summary a{white-space:normal}}
    `;
    document.head.appendChild(style);
  };

  const trackCta = (kind, product) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'mcor_fit_guide_cta_click',
      mcor_cta_kind: kind,
      product_id: product.id,
      product_title: product.title,
      product_vendor: product.vendor,
    });
  };

  const productKind = (product) => {
    const tags = Array.isArray(product.tags) ? product.tags.join(' ') : product.tags || '';
    const productType = String(product.type || product.product_type || '').trim();
    const corpus = `${productType} ${product.title || ''} ${tags}`.toLowerCase();
    if (/marine|powersports/.test(corpus)) return null;
    if (productType === 'Motor Vehicle Amplifiers') return 'amplifier';
    if (['Motor Vehicle Subwoofers', 'Loaded Subwoofer Enclosure'].includes(productType)) return 'subwoofer';
    if (productType === 'Motor Vehicle Speakers') return 'speaker';
    return null;
  };

  const productHandle = () => {
    const canonical = document.querySelector('link[rel="canonical"]')?.href || window.location.href;
    const match = new URL(canonical, window.location.origin).pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  };

  const loadProduct = async () => {
    const handle = productHandle();
    if (!handle) return null;
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return null;
    return response.json();
  };

  const panelContent = (kind, savedLabel) => {
    if (kind === 'speaker') {
      return {
        eyebrow: 'Vehicle fitment check',
        heading: 'Make sure this speaker fits your vehicle',
        copy: savedLabel
          ? `Check the factory speaker opening and the brackets or harnesses required for your saved ${savedLabel}.`
          : 'Choose your vehicle to see the factory speaker locations, opening sizes, and installation parts that apply.',
        cta: 'Check this speaker for my vehicle',
        anchor: 'mfg-speakers',
        secondary: '/collections/jl-audio?filter.p.product_type=Motor%20Vehicle%20Speakers',
        secondaryLabel: 'Compare all JL Audio car speakers',
      };
    }
    if (kind === 'amplifier') {
      return {
        eyebrow: 'Complete the installation',
        heading: 'Plan the complete amplifier system',
        copy: savedLabel
          ? `Find the factory-audio integration path and vehicle-specific signal connections for your saved ${savedLabel}.`
          : 'Choose your vehicle to find applicable factory-audio integration interfaces, signal connections, and installation paths.',
        cta: 'Find integration parts for my vehicle',
        anchor: 'mfg-audio-upgrades',
        secondary: '/collections/jl-audio?filter.p.product_type=Motor%20Vehicle%20Amplifiers',
        secondaryLabel: 'Compare JL Audio amplifiers',
      };
    }
    return {
      eyebrow: 'Build the complete bass system',
      heading: 'Plan the enclosure, amplifier, and vehicle integration',
      copy: savedLabel
        ? `See vehicle-specific enclosure and factory-audio integration options for your saved ${savedLabel}; amplifier and enclosure matching still depends on the complete system design.`
        : 'Choose your vehicle to see exact-fit enclosure and integration options, then match the subwoofer, enclosure, and amplifier as one system.',
      cta: 'Plan the complete subwoofer system',
      anchor: 'mfg-audio-upgrades',
      secondary: '/collections/jl-audio?filter.p.product_type=Loaded%20Subwoofer%20Enclosure',
      secondaryLabel: 'Shop JL Audio loaded enclosures',
    };
  };

  const renderProductBridge = async () => {
    if (!window.location.pathname.includes('/products/')) return;
    const product = await loadProduct().catch(() => null);
    if (!product || String(product.vendor || '').trim().toLowerCase() !== 'jl audio') return;

    const kind = productKind(product);
    if (!kind || document.querySelector('[data-mcor-jl-conversion]')) return;
    const info = document.querySelector('product-info .product__info-container, .product__info-container');
    const purchaseForm = info?.querySelector('product-form, .product-form');
    if (!info || !purchaseForm) return;

    const savedLabel = vehicleLabel(readVehicle());
    const content = panelContent(kind, savedLabel);
    const panel = document.createElement('section');
    panel.className = 'mcor-jl-conversion';
    panel.dataset.mcorJlConversion = kind;
    panel.setAttribute('aria-labelledby', 'McorJlConversionHeading');
    panel.innerHTML = `
      <p class="mcor-jl-conversion__eyebrow">${content.eyebrow}</p>
      <h2 id="McorJlConversionHeading">${content.heading}</h2>
      <p class="mcor-jl-conversion__copy">${content.copy}</p>
      <div class="mcor-jl-conversion__actions">
        <a class="mcor-jl-conversion__primary" data-mcor-jl-primary href="${fitGuideUrl(content.anchor)}">${content.cta}</a>
        <a class="mcor-jl-conversion__secondary" href="${content.secondary}">${content.secondaryLabel}</a>
      </div>
      <div class="mcor-jl-trust" aria-label="Why buy JL Audio from MCOR">
        <span>Authorized JL Audio retailer</span>
        <span>Trusted by hundreds of verified customers</span>
        <span>Installation expertise since 2004</span>
        <span>Fast U.S. shipping and straightforward returns</span>
      </div>
    `;
    purchaseForm.insertAdjacentElement('beforebegin', panel);
    panel.querySelector('[data-mcor-jl-primary]')?.addEventListener('click', () => trackCta(kind, product));
  };

  const activeJlFilter = () => {
    if (!/^\/collections\/jl-audio\/?$/.test(window.location.pathname)) return null;
    const params = new URLSearchParams(window.location.search);
    const active = [...params.entries()].find(([key, value]) => key.startsWith('filter.') && value);
    return active ? active[1] : null;
  };

  const renderFilteredCollection = () => {
    const filterValue = activeJlFilter();
    if (!filterValue) return;
    document.body.classList.add('mcor-jl-filtered-collection');
    const facets = document.querySelector('.facets-container');
    if (!facets || document.querySelector('[data-mcor-jl-filter-summary]')) return;

    const summary = document.createElement('div');
    summary.className = 'mcor-jl-filter-summary page-width';
    summary.dataset.mcorJlFilterSummary = '';
    summary.innerHTML = `
      <div><strong>JL Audio ${filterValue}</strong><span>Showing the products in the category you selected.</span></div>
      <a href="/collections/jl-audio">View the complete JL Audio collection</a>
    `;
    facets.insertAdjacentElement('beforebegin', summary);
  };

  const init = () => {
    addStyles();
    renderFilteredCollection();
    renderProductBridge();
  };

  document.addEventListener('DOMContentLoaded', init, { once: true });
})();
